import { useState } from "react";

export const LazyImage = ({ src, alt = "", style = {}, className = "", radius = 0, onClick }: any) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div
      onClick={onClick}
      className={"lazy-image" + (loaded ? "" : " card-img1-loading") + (className ? " " + className : "")}
      style={{ width: "100%", height: "100%", overflow: "hidden", ...style }}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onDragStart={(e) => e.preventDefault()}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          borderRadius: radius,
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
        }}
      />
    </div>
  );
};
